import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import offSiteGridLPColumns from "./offSiteGridLPColumns";
import offSiteGridAffiColumns from "./offSiteGridAffiColumns";
import offSiteGridBoostColumns from "./offSiteGridBoostColumns";
import offSiteGridDiscColumns from "./offSiteGridDiscColumns";
import offSiteGridFillingColumns from "./offSiteGridFillingColumns";
import offSiteGridLeadColumns from "./offSiteGridLeadColumns";
import offSiteGridNLColumns from "./offSiteGridNLColumns";
import offSiteGridRankColumns from "./offSiteGridRankColumns";
import offSiteGridSellColumns from "./offSiteGridSellColumns";
import offSiteGridSiloColumns from "./offSiteGridSiloColumns";
import { useIntl } from "react-intl";
import offSiteGridPlannedColumns from "./offSiteGridPlannedColumns";
import { TOffSiteOrderType } from "src/app/types/orders/order";
import { SimpleEntityGridActionCellButton } from "../../grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";
import { OrderOffSiteGrid } from "src/app/types/orders/offSite";
import offSiteGridHistoryColumns from "./offSiteGridHistoryColumns";

export type THandleActionModals = (
    modelName: SimpleEntityGridActionCellButton,
    data: OrderOffSiteGrid
) => void;
export type TActionData = {
    actions: Array<{ name: SimpleEntityGridActionCellButton; icon: string }>;
    actives: Array<SimpleEntityGridActionCellButton>;
    width: number;
    handleActionModals: THandleActionModals;
};

export function useSiteAnalyzeOffSiteGridColumns(
    orderType: TOffSiteOrderType,
    handleActionModals: THandleActionModals
): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();
    const actions: Array<{ name: SimpleEntityGridActionCellButton; icon: string }> = [
        { name: "sendText", icon: "/media/icons/duotune/text/txt001.svg" },
        { name: "netlinking", icon: "/media/icons/duotune/files/fil022.svg" },
        { name: "silo", icon: "/media/icons/duotune/coding/cod002.svg" },
        { name: "indexMe", icon: "/media/icons/duotune/communication/com008.svg" },
        { name: "disable", icon: "/media/icons/duotune/arrows/arr015.svg" },
    ];
    const activeActions = actions.map((el) => el.name);

    const actionsWidth = actions?.length * 33.25 + 2 * 11 + 1;
    const actionData = {
        actions,
        actives: activeActions,
        width: actionsWidth,
        handleActionModals,
    };

    switch (orderType) {
        case "LP":
            return offSiteGridLPColumns(formatMessage, actionData);
        case "NL":
            return offSiteGridNLColumns(formatMessage, actionData);
        case "FILLING":
            return offSiteGridFillingColumns(formatMessage, actionData);
        case "BOOST":
            return offSiteGridBoostColumns(formatMessage, actionData);
        case "SILO":
            return offSiteGridSiloColumns(formatMessage, actionData);
        case "SELL":
            return offSiteGridSellColumns(formatMessage, actionData);
        case "RANK":
            return offSiteGridRankColumns(formatMessage, actionData);
        case "LEAD":
            return offSiteGridLeadColumns(formatMessage, actionData);
        case "DISC":
            return offSiteGridDiscColumns(formatMessage, actionData);
        case "AFFI":
            return offSiteGridAffiColumns(formatMessage, actionData);
        case "PLANNED":
            return offSiteGridPlannedColumns(formatMessage);
        case "HISTORY":
            return offSiteGridHistoryColumns(formatMessage);
    }

    return offSiteGridLPColumns(formatMessage, actionData);
}
